import _ from "lodash";
import React from "react";
import { useIntl } from "react-intl";

import Uploader from "./Uploader";
import ImagePreview from "./ImagePreview";

export const LandingButtonsArrayValues = (props) => {
  const { values = [], changeValues } = props;
  const intl = useIntl();
  return (
    <div>
      {_.map(values, (elem, index) => {
        return (
          <div className="row mb-1" key={index}>
            <div className="col-10">
              <div className="row">
                <div className="col-4">
                  <input
                    type="string"
                    name="title"
                    className="form-control"
                    placeholder={intl.formatMessage({ id: "text" })}
                    value={elem.title || ""}
                    onChange={({ target }) => {
                      Object.assign(values[index], { title: target.value });
                      changeValues(values);
                    }}
                  />
                </div>
                <div className="col-4">
                  <input
                    type="string"
                    name="url"
                    className="form-control"
                    placeholder={intl.formatMessage({ id: "url" })}
                    value={elem.url || ""}
                    onChange={({ target }) => {
                      Object.assign(values[index], { url: target.value });
                      changeValues(values);
                    }}
                  />
                </div>
                <div className="col-4">
                  {elem.fileId ? (
                    <ImagePreview
                      file={{ _id: elem.fileId }}
                      deleteHandler={() => {
                        Object.assign(values[index], { fileId: null });
                        changeValues(values);
                      }}
                    />
                  ) : (
                    <Uploader
                      className="btn-success btn-sm pull-right"
                      successHandler={([file]) => {
                        Object.assign(values[index], { fileId: file._id });
                        changeValues(values);
                      }}
                      imagesOnly="true"
                      multiple={false}
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="col text-right">
              <LandingButtonsArrayValues.RemoveButton {...props} index={index} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

LandingButtonsArrayValues.AddButton = (props) => {
  const { values = [], changeValues } = props;
  const addValue = () => {
    changeValues(values.concat([{}]));
  };
  return (
    <button className={`btn btn-success ${props.className}`} onClick={addValue}>
      <i className="fa fa-plus" />
    </button>
  );
};

LandingButtonsArrayValues.RemoveButton = (props) => {
  const { values = [], changeValues } = props;
  const removeValue = () => {
    changeValues(values.filter((elem, index) => index !== props.index));
  };
  return (
    <button className={`btn btn-sm btn-danger`} onClick={removeValue}>
      <i className="fa fa-minus" />
    </button>
  );
};

export default LandingButtonsArrayValues;
